var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'meeting-info': true,
    'meeting-info-canceled': _vm.meetingStatus === 6 && _vm.endType === 3
  }},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.topicOfLang))]),_c('div',{class:_vm.meetingStatusTextClass},[_vm._v(" "+_vm._s(_vm.meetingStatusDesc)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }